import { IConstellation } from "config/types";
import { getPreVerifiedInitialData, getVerifiedInitialData } from "store/actions/appLoad";
import { logout } from "store/actions/authentication";
import { getDashboardData } from "store/actions/dashboard";
import { createIdentifiedUser } from "store/actions/user";
import { getActiveConstellation } from "utils/constellation";

import { createReducer } from "@reduxjs/toolkit";

/* ------------    CONSTELLATION STATE     ------------------ */
const defaultState: Omit<
  IConstellation,
  "allocationSummary" | "allocationHistories" | "wyshAllocations"
> = {
  id: "",
  createdAt: "",
  label: "",
  featureFlags: [],
  status: "",
};

/* ------------    REDUCER     ------------------ */
const constellation = createReducer(defaultState, builder => {
  builder
    .addCase(getPreVerifiedInitialData.fulfilled, (state, action) => {
      const constellation = getActiveConstellation(action.payload.me.activeConstellations) || state;

      state.id = constellation.id;
      state.createdAt = constellation.createdAt;
      state.featureFlags = constellation.featureFlags;
      state.label = constellation.label;
    })
    .addCase(getVerifiedInitialData.fulfilled, (state, action) => {
      const constellation = getActiveConstellation(action.payload.me.activeConstellations) || state;

      state.id = constellation.id;
      state.createdAt = constellation.createdAt;
      state.label = constellation.label;
      state.featureFlags = constellation.featureFlags || state.featureFlags;
      state.status = constellation.status;
    })
    .addCase(createIdentifiedUser.fulfilled, (state, action) => {
      const constellations = action.payload.activeConstellations;
      const latestConstellation = getActiveConstellation(constellations) || defaultState;

      state.id = latestConstellation.id;
      state.featureFlags = latestConstellation.featureFlags;
    })
    .addCase(getDashboardData.fulfilled, (state, action) => {
      const constellation = action.payload;

      state.featureFlags = constellation?.featureFlags || state.featureFlags;
      state.label = constellation.label || state.label;
    })
    .addCase(logout, () => defaultState);
});

export default constellation;
